export const visit = (vm, at) => {
at({ "en": { "thirdPartyHelpDeskPopover": { "callFrom": "Call from: {{provider}}", "selectProviderError": "<b>There was a problem changing your calling provider.</b> Please refresh the page and try again.", "changeCallingProvider": "Change calling provider" } } });
};